import { RouterLink } from '@redux-first-router-link';
import DocumentHeader from '@/components/DocumentHeader';
import { Button } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import { ROUTE_PORTFOLIO_DEMO } from '@/constants/routes';
import { useFlag } from '@/features/unleash';
import { NewManualPortfolio } from './components/NewManualPortfolio';
import { NewLinkedPortfolio } from './components/NewLinkedPortfolio';
import { PromoFeatures } from './components/PromoFeatures';
import loadable from '@loadable/component';

const NewTransactionPortfolio = loadable(
  () => import('./components/NewTransactionPortfolio'),
  {
    resolveComponent: (c) => c.NewTransactionPortfolio,
  }
);

// TODO: When 'mono-portfolio-new-page' flag is deprecated, move this into `NewPortfolio.tsx`
export const NewPortfolioPage = () => {
  const linkingFlag = useFlag({ name: 'mono-portfolio-linking' });
  const transactionsFlag = useFlag({
    name: 'mono-portfolio-transactions-table',
  });

  if (!linkingFlag.flagsReady) return;
  if (!transactionsFlag.flagsReady) return;

  return (
    <>
      <DocumentHeader title="New Portfolio" />
      <section className="w-full sm:px-[2.4rem] sm:py-x4 max-w-screen-xl grid sm:gap-x4 text-solid">
        <div className="flex flex-wrap justify-between items-center gap-x-x4 gap-y-x2 px-x2 py-x4 sm:p-0">
          <div className="grid gap-x1">
            <Heading size="xLarge">
              Welcome! Let’s get your portfolio set up
            </Heading>
            <div className="text-softer text-xs">
              You’re just minutes away from actionable insights to grow your
              portfolio.
            </div>
          </div>
          <div className="flex flex-wrap gap-x-x1 gap-y-x1_5">
            <Button
              to={{ type: ROUTE_PORTFOLIO_DEMO }}
              as={RouterLink}
              styleType="loud"
              className="w-fit whitespace-nowrap focus-visible:ring-2 focus-visible:duration-0 focus-visible:ring-accent ![font-size:theme(fontSize.xs)]"
            >
              <span className="pr-x0_25 scale-105 inline-block">🍿</span> View
              demo portfolio
            </Button>
          </div>
        </div>
        {transactionsFlag.enabled ? (
          <div className="grid gap-x2 sm:gap-x3 sm:grid-cols-2 lg:grid-cols-[61.8%_auto]">
            {linkingFlag.enabled && (
              <section className="flex flex-col gap-x2 sm:gap-x3 bg-surface-1 sm:rounded-lg py-x3 sm:max-lg:col-span-2 lg:row-span-2">
                <NewLinkedPortfolio />
              </section>
            )}
            <section className="bg-surface-1 sm:rounded-lg px-x2 py-x3 sm:p-x3 sm:max-lg:[&>*]:h-full">
              <NewManualPortfolio />
            </section>
            <section className="bg-surface-1 sm:rounded-lg px-x2 py-x3 sm:p-x3 sm:max-lg:[&>*]:h-full">
              <NewTransactionPortfolio />
            </section>
          </div>
        ) : (
          <div className="grid gap-x2 sm:gap-x3 md:grid-cols-[61.8%_auto]">
            {linkingFlag.enabled && (
              <section className="flex flex-col gap-x2 sm:gap-x3 bg-surface-1 sm:rounded-lg py-x3">
                <NewLinkedPortfolio />
              </section>
            )}
            <section className="bg-surface-1 sm:rounded-lg px-x2 py-x3 sm:p-x3">
              <NewManualPortfolio />
            </section>
          </div>
        )}
        <PromoFeatures />
      </section>
    </>
  );
};
